import { render, staticRenderFns } from "./LogoUploader.vue?vue&type=template&id=324e2352&scoped=true"
import script from "./LogoUploader.vue?vue&type=script&lang=js"
export * from "./LogoUploader.vue?vue&type=script&lang=js"
import style0 from "./LogoUploader.vue?vue&type=style&index=0&id=324e2352&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324e2352",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('324e2352')) {
      api.createRecord('324e2352', component.options)
    } else {
      api.reload('324e2352', component.options)
    }
    module.hot.accept("./LogoUploader.vue?vue&type=template&id=324e2352&scoped=true", function () {
      api.rerender('324e2352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/display-builder/LogoUploader.vue"
export default component.exports